// extracted by mini-css-extract-plugin
module.exports = {"container":"PubgPageBanner_container__2RwRN"};